module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/logo_c02-93ed4d9c895e6345aafcc210be21736e.jpg";